import { QuickTimes, QuickTimeRec } from './QuickTimes';

export const BlankQuickTimes: QuickTimes = {
    lastAdvNum: '',
    lastAdvName: '',
    lastTransType: '',
    BuiltTime: 0,
    Built: false,
    RC: '',
};

export const TestQuickTimes: QuickTimes = {
    lastAdvNum: '999',
    lastAdvName: 'Test Adv',
    lastTransType: 'W',
    BuiltTime: 123,
    Built: true,
    RC: '',
};

export const BlankQuickTimeRec: QuickTimeRec[] = [];
export const TestQuickTimeRec: QuickTimeRec[] = [
    {
        id: '0',
        displayDate: 'July 27 2020',
        displayTime: '12:30pm',
        transFlag: '03',
        adv: '999',
        checked: false,
        modeFlag: '',
    },
    {
        id: '1',
        displayDate: 'July 28, 2020',
        displayTime: '12:30pm',
        transFlag: '03',
        adv: '999',
        checked: false,
        modeFlag: '',
    },
    {
        id: '2',
        displayDate: 'July 28, 2020',
        displayTime: '12:30pm',
        transFlag: '06',
        adv: '01',
        checked: false,
        modeFlag: '',
    },
];

